/**************************************************
 * Nombre:       Icono_Texto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {irUrl} from "../../../Utilidades/irUrl";

const Icono_Texto = ({Icono, texto, url, dir = 'flex-start'}) => {

    return (
        <Grid
            onClick={() => irUrl(url)}
            container
            justifyContent={dir}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                cursor: 'pointer',

            }}
        >


            <Typography sx={{color: '#fff', fontSize: 12}}> <span> <Icono sx={{fill: '#fff', pr: 1, mt: 0, mb: -1}}/></span> {texto}
            </Typography>


        </Grid>
    )

}
export default Icono_Texto